var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serp",attrs:{"id":"serp"}},[_c('TopMenu',{ref:"topMenu",on:{"showFilter":function($event){return _vm.$refs.tours.showFilter()}}}),_c('Tours',{ref:"tours"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }